import React from 'react'
import styles from './iconLabeled.module.css'

class IconLabeled extends React.Component {
  getLabel() {
    if (!this.props.link) {
      return <span className={styles.label}>{this.props.label}</span>
    }

    return (
      <a className={styles.label} href={this.props.link}>
        {this.props.label}
      </a>
    )
  }

  render() {
    const label = this.getLabel()
    return (
      <div className={styles.iconLabeled}>
        {this.props.children}
        {label}
      </div>
    )
  }
}

export default IconLabeled
